import { render } from "./AdminEventEdit.vue?vue&type=template&id=172d7a9b&scoped=true&ts=true"
import script from "./AdminEventEdit.vue?vue&type=script&lang=ts"
export * from "./AdminEventEdit.vue?vue&type=script&lang=ts"

import "./AdminEventEdit.vue?vue&type=style&index=0&id=172d7a9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172d7a9b"]])

export default __exports__